import { compact, map } from "lodash";
import { SignalingGetLogResponse } from "../../proto/SignalingGetLog_pb";
import store from "../../store";
import { setSignalingLogList } from "../../store/signalingLogList/actions";
import { addUsers } from "../../store/users/actions";
import BaseHandler from "../BaseHandler";

export default class HandleSignalingGetLogResponse extends BaseHandler<SignalingGetLogResponse> {
  handle() {
    const signalingGetLogResponse = this.response.toObject();
    store.dispatch(setSignalingLogList(signalingGetLogResponse.signalingLogList));
    store.dispatch(addUsers(compact(map(signalingGetLogResponse.signalingLogList, "peer"))));
  }
}
